/**
 * WordPress environment waits (platform layer)
 *
 * @since 1.65.0
 */

(function (pmw) {

	/**
	 * Wait until jQuery is available. WordPress enqueues it as a dependency
	 * of the Pixel Manager script, but JS optimizers can reorder loading.
	 *
	 * @returns {Promise<void>}
	 */
	pmw.jQueryExists = async () => new Promise(resolve => {

		(function waitForjQuery() {
			if (typeof jQuery !== "undefined") return resolve()
			setTimeout(waitForjQuery, 100)
		})()
	})

}(window.pmw = window.pmw || {}));
